import { SkuSlaDTO } from '../../../../../domains/slaDomain';
import SLASupplierPrice from './SLASupplierPrice';
import SLABuyerPrice from './SLABuyerPrice';
import { DeleteIcon } from '../../../../../components/Icons';
import RevxFlexLayout from '../../../../../components/RevxFlexLayout';
import slaService from '../../../../../services/slaService';
import { useAppDispatch } from '../../../../../app/hooks';

type SLASkuProps = {
  data: SkuSlaDTO;
};

const SLASku = ({ data }: SLASkuProps) => {
  const { skuName, id, supplierConfig, buyerConfig } = data;
  const dispatch = useAppDispatch();
  const deleteSla = async () => {
    await slaService.deleteSla(id);
    dispatch.sla.deleteSla(id);
  };
  return (
    <div className="sku-item mt-20">
      <RevxFlexLayout className="sku-item__title" justify="space-between">
        <span>sku name: {skuName}</span>
        <span className="click" onClick={deleteSla}>
          <DeleteIcon />
        </span>
      </RevxFlexLayout>
      <div className="sku-item__content">
        <SLASupplierPrice id={id} config={supplierConfig} />
        <SLABuyerPrice
          id={id}
          config={buyerConfig}
          maxQty={supplierConfig.maxQty}
        />
      </div>
    </div>
  );
};
export default SLASku;
